import {
  ContractExtensionEligibilityInfo,
  ContractExtensionOption,
} from '@/models/contractExtension/ContractExtensionEligibilityModel';
import i18n from '@/i18n';

export interface ContractExtensionOptionWithPrice extends ContractExtensionOption {
  title: string;
}

export const formatExtensionOptionsWithPrice = (
  extendContractInfo: ContractExtensionEligibilityInfo,
): ContractExtensionOptionWithPrice[] => {
  return extendContractInfo.extensionOptions.map((option) => {
    const numberToDivide = 12;
    const price = option.price / numberToDivide;
    return {
      ...option,
      title: `${i18n.tc('postgradContractExtension.buttonInformation.price', option.period, {
        period: option.period,
        price: price.toFixed(2),
        times: numberToDivide,
      })}`,
    };
  });
};
